import { render, staticRenderFns } from "./CreateGroupStudentsDialog.vue?vue&type=template&id=1e456aea"
import script from "./CreateGroupStudentsDialog.vue?vue&type=script&lang=js"
export * from "./CreateGroupStudentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports